import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import bannerMonitor from '../../assets/banner_monitor.png';
import HeatmapMode from './elements/HeatmapMode';

const MonitorPage: React.FC = () => {

  return (
    <div className="bg-white min-h-screen">
      {/* Hero Banner Section */}
      <div className="px-4 sm:px-8 lg:px-16 xl:px-24 pt-24 pb-12">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 mb-6">
          <Link
            to="/"
            className="text-gray-500 hover:text-gray-700 transition-colors"
            style={{
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: 400
            }}
          >
            Home
          </Link>
          <ChevronRight className="w-4 h-4 text-gray-400" />
          <span
            className="text-gray-700"
            style={{
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: 500
            }}
          >
            Monitor
          </span>
        </div>

        {/* Banner */}
        <div className="relative w-full h-[400px] rounded-[32px] overflow-hidden">
          <img
            src={bannerMonitor}
            alt="Monitor Banner"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Content Section */}
      <div className="px-4 sm:px-8 lg:px-16 xl:px-24 pb-12">
        {/* Real-time Crowd Heatmap Section */}
        <div className="bg-white border border-gray-200 rounded-2xl shadow-lg overflow-hidden p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2
              style={{
                fontFamily: 'Poppins',
                fontSize: '24px',
                fontWeight: 700,
                color: '#000000'
              }}
            >
              Real-time Crowd Heatmap
            </h2>
            <span
              style={{
                fontFamily: 'Inter',
                fontSize: '14px',
                fontWeight: 400,
                color: '#667479'
              }}
            >
              15:14:00 · 8 Oct 2025
            </span>
          </div>

          {/* Map Content */}
          <HeatmapMode />
        </div>
      </div>
    </div>
  );
};

export default MonitorPage;
